type CanNotDelete = { canDelete: false; reason?: string };
type CanDelete = { canDelete: true };

export type CanDeleteOutput = CanDelete | CanNotDelete;
export type CanDeleteFn = (selectedIndexes: string[]) => CanDeleteOutput;

export function getReason(canDeleteOutput: CanDeleteOutput): string | undefined {
	return canDeleteOutput?.canDelete ? undefined : canDeleteOutput?.reason;
}
